module.exports = __webpack_public_path__ + "static/media/Batsuuri.69e361e7.png";